import type { MutateAudienceType } from 'src/api/generated/touring/types';

type MapTaskFormAudienceArgsType = {
  values: { userIds: string[]; teamIds: string[] };
};

export const mapTaskFormAudience = ({
  values,
}: MapTaskFormAudienceArgsType): MutateAudienceType[] => [
  ...values.userIds.map((id) => ({ id, type: 'PERSON' as const })),
  ...values.teamIds.map((id) => ({ id, type: 'TEAM' as const })),
];
